export function supportsRowsPerPage(options: ListViewOptions): boolean {
    return options.display === 'cardV2'
}
